Router = App.loadClass 'core::Router'

class exports.Router extends Router

    prefix: 'BuyerLocation'
    module_name: 'BuyerLocationRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        @service 'grower::Angular/BuyerLocation/LocationService', ['$http']

        @controller 'grower::Angular/BuyerLocation/LocationController', [
            '$scope'
            '$transitions'
            '$state'
            'BuyerLocation.Services.LocationService'
        ]

        @controller 'grower::Angular/BuyerLocation/PlacementController', [
            '$scope'
            '$transitions'
            '$state'
            'BuyerLocation.Services.LocationService'
            '$timeout'
        ]

        @controller 'grower::Angular/BuyerLocation/IdentificationController', [
            '$scope'
            '$transitions'
            '$state'
            'BuyerLocation.Services.LocationService'
        ]

    registerRoutes: ($stateProvider) ->
        $stateProvider
            .state 'grower.buyerlocation',
                url: '/buyerlocation/:locationId?fpcResultId&step'
                templateUrl: 'backend/grower/buyer-location/sidebar'
                controller: [
                    '$scope',
                    '$state',
                    'BuyerLocation.Services.LocationService',
                    '$http'

                    ($scope, $state, $location, $http) ->
                        $scope.show_fullpage = false

                        $location.params = $state.params
                        $location.setAllLocations()

                        if $state.params.locationId
                            $http.post 'backend/grower/buyer-location/load',
                                locationId: +$state.params.locationId
                            .then (response) =>
                                $location.new = response.data.data
                                $location.createFeatureGroup()
                                $state.go 'grower.buyerlocation.place'
                        else
                            $location.reset()
                            $state.go 'grower.buyerlocation.locate'
                ]

            .state 'grower.buyerlocation.locate',
                url: '/locate'
                views:
                    'sidebar-step@grower.buyerlocation':
                        templateUrl: 'backend/grower/buyer-location/locate'
                        controller: 'BuyerLocation.Controllers.LocationController'


            .state 'grower.buyerlocation.place',
                url: '/place'
                views:
                    'sidebar-step@grower.buyerlocation':
                        templateUrl: 'backend/grower/buyer-location/place'
                        controller: 'BuyerLocation.Controllers.PlacementController'

            .state 'grower.buyerlocation.identify',
                url: '/identify'
                views:
                    'sidebar-step@grower.buyerlocation':
                        templateUrl: 'backend/grower/buyer-location/identify'
                        controller: 'BuyerLocation.Controllers.IdentificationController'
